export default __webpack_public_path__ + "static/media/vaishnavi_sharma_content_team_lead.ccce728f.jpg";